import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Typography, Container, CircularProgress } from '@mui/material';
import "./Register.css";
import logo from './assets/Logo.png';  // اضافه کردن تصویر لوگو

function Register() {
    const [userData, setUserData] = useState({
        name: "", phone: "", email: "", address: "", postalCode: "", password: "", confirmPassword: ""
    });
    const [errors, setErrors] = useState({});
    const [generalError, setGeneralError] = useState("");
    const [serviceUnavailable, setServiceUnavailable] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // غیرفعال کردن اسکرول صفحه هنگام نمایش فرم ثبت‌نام
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

const handleInputChange = (e) => {
    let { name, value } = e.target;

    if (name === "postalCode") {
        value = value.toUpperCase().replace(/\s/g, "");
        if (value.length >= 3) {
            value = value.slice(0, 3) + (value.length > 3 ? " " + value.slice(3) : "");
        }
    } else if (name === "phone") {
        // حذف تمام خط تیره‌ها
        let digits = value.replace(/-/g, "");
        // محدود کردن به 10 رقم
        if (digits.length > 10) {
            digits = digits.slice(0, 10);
        }
        // افزودن خط تیره پس از سه رقم اول و سه رقم دوم
        if (digits.length > 3 && digits.length <= 6) {
            value = digits.slice(0, 3) + '-' + digits.slice(3);
        } else if (digits.length > 6) {
            value = digits.slice(0, 3) + '-' + digits.slice(3, 6) + '-' + digits.slice(6);
        } else {
            value = digits;
        }
    }

    setUserData(prevState => ({
        ...prevState,
        [name]: value
    }));

    if (errors[name]) {
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ""
        }));
    }
};

const validateFields = () => {
    const newErrors = {};
    if (!userData.name.trim()) newErrors.name = "Name is required!";

    if (!userData.phone.trim()) {
        newErrors.phone = "Phone number is required!";
    } else {
        // حذف خط تیره‌ها برای اعتبارسنجی دقیق تعداد ارقام
        const phoneDigits = userData.phone.replace(/-/g, "");
        if (phoneDigits.length !== 10) {
            newErrors.phone = "Phone number must be exactly 10 digits!";
        }
    }

    if (!userData.email.trim()) {
        newErrors.email = "Email is required!";
    } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(userData.email)) newErrors.email = "Invalid email format!";
    }

    if (!userData.address.trim()) newErrors.address = "Address is required!";

    if (!userData.postalCode.trim()) {
        newErrors.postalCode = "Postal code is required!";
    } else {
        const postalRegex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;
        if (!postalRegex.test(userData.postalCode))
            newErrors.postalCode = "Format should be like K9H0K1 or K9H 0K1!";
    }

    if (!userData.password) {
        newErrors.password = "Password is required!";
    } else if (userData.password.length < 6) {
        newErrors.password = "At least 6 characters required!";
    }

    if (!userData.confirmPassword) {
        newErrors.confirmPassword = "Please confirm your password!";
    } else if (userData.password !== userData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match!";
    }
    
    return newErrors;
};


    const handleRegister = async () => {
        setGeneralError("");
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setLoading(true);


        try {
        // اصلاح کد پستی: تبدیل به حروف بزرگ و اضافه کردن فاصله
        let formattedPostalCode = userData.postalCode.toUpperCase().replace(/\s/g, "");
        if (formattedPostalCode.length === 6) {
            formattedPostalCode = formattedPostalCode.slice(0, 3) + " " + formattedPostalCode.slice(3);
        }

        const updatedUserData = { ...userData, postalCode: formattedPostalCode };

        // ثبت اطلاعات مشتری
        const response = await fetch("https://carcure.ca/backend/register", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updatedUserData)
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.message);

        // استخراج سه کاراکتر اول کد پستی
        const postalPrefix = formattedPostalCode.substring(0, 3);

        // ارسال درخواست بررسی منطقه سرویس
        const areaResponse = await fetch("https://carcure.ca/backend/check-working-area", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ postalPrefix })
        });

        const areaResult = await areaResponse.json();

        if (!areaResult.found) {
            await fetch("https://carcure.ca/backend/update-client-info", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ name: userData.name, status: "NA" })
            });
            setServiceUnavailable(true);
            setGeneralError("Thank you for registering. Unfortunately, service is not currently available in your area. We will notify you as soon as service becomes available.");
            setLoading(false);
            return;
        }

        // نمایش پیام موفقیت و هدایت به صفحه اصلی
        alert(data.message);
        navigate('/');
    } catch (error) {
        setGeneralError(error.message);
    }

    setLoading(false);
};







    // دکمه بستن فرم
    const handleClose = () => {
        navigate('/');
    };

    if (serviceUnavailable) {
        return (
            <Container maxWidth="sm" className="register-container">
                <Typography variant="h5" gutterBottom>
                    Thank you for registering. Unfortunately, service is not currently available in your area. We will notify you as soon as service becomes available.
                </Typography>
                <Button variant="contained" color="primary" fullWidth onClick={handleClose}>
                    Return to Home
                </Button>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm" className="register-container">
            <button className="close-button" onClick={handleClose}>×</button>
            {/* نمایش لوگو در بالای فرم */}
            <div className="logo-container">
                <img src={logo} alt="Logo" className="login-logo" />
            </div>
            {generalError && (
                <Typography color="error" style={{ marginBottom: '10px', textAlign: 'center' }}>
                    {generalError}
                </Typography>
            )}
            <TextField 
                fullWidth 
                label="Name" 
                name="name" 
                value={userData.name} 
                onChange={handleInputChange} 
                margin="normal" 
                autoFocus
                placeholder="Enter your name"
                title="Your full name"
                error={Boolean(errors.name)}
                helperText={errors.name}
            />
            <TextField 
                fullWidth 
                label="Phone" 
                name="phone" 
                value={userData.phone} 
                onChange={handleInputChange} 
                margin="normal" 
                placeholder="e.g., 1234567890"
                title="Enter at least 10 digits"
                error={Boolean(errors.phone)}
                helperText={errors.phone}
            />
            <TextField 
                fullWidth 
                label="Email" 
                name="email" 
                value={userData.email} 
                onChange={handleInputChange} 
                margin="normal" 
                type="email" 
                autoComplete="off"  
                placeholder="example@domain.com"
                title="Enter a valid email address"
                error={Boolean(errors.email)}
                helperText={errors.email}
            />
            <TextField 
                fullWidth 
                label="Address" 
                name="address" 
                value={userData.address} 
                onChange={handleInputChange} 
                margin="normal"
                placeholder="Enter your address"
                title="Your current address"
                error={Boolean(errors.address)}
                helperText={errors.address}
            />
           <TextField 
    fullWidth 
    label="Postal Code" 
    name="postalCode" 
    value={userData.postalCode}  // مقدار به‌روز شده
    onChange={handleInputChange} 
    margin="normal"
    placeholder="e.g., K9H0K1"
    title="Format: K9H 0K1"
    error={Boolean(errors.postalCode)}
    helperText={errors.postalCode}
/>

            <TextField 
                fullWidth 
                label="Password" 
                name="password" 
                value={userData.password} 
                onChange={handleInputChange} 
                margin="normal" 
                type="password" 
                autoComplete="new-password" 
                placeholder="Enter your password"
                title="At least 6 characters required"
                error={Boolean(errors.password)}
                helperText={errors.password}
            />
            <TextField 
                fullWidth 
                label="Confirm Password" 
                name="confirmPassword" 
                value={userData.confirmPassword} 
                onChange={handleInputChange} 
                margin="normal" 
                type="password" 
                autoComplete="new-password" 
                placeholder="Re-enter your password"
                title="Must match the password"
                error={Boolean(errors.confirmPassword)}
                helperText={errors.confirmPassword}
            />
            <Button 
                variant="contained" 
                color="primary" 
                fullWidth 
                onClick={handleRegister} 
                style={{ marginTop: "10px" }}
                disabled={loading}
            >
                {loading ? <CircularProgress size={24} color="inherit" /> : "Register"}
            </Button>
        </Container>
    );
}

export default Register;
